<div class="container">
  <div class="form" [class.disabled]="isAdmin">
    <div class="form-group inline">
      <div class="label">
        Username
      </div>
      <input type="text" [(ngModel)]="userModel.username" name="username" #userName="ngModel" />
    </div>
    <div class="form-group inline">
      <div class="label">
        Password
      </div>
      <input type="password" [(ngModel)]="userModel.password" name="password" #password="ngModel" />
    </div>
    <div class="submit">
      <button class="wire-btn" (click)="logIn()" *ngIf="!isAdmin">Submit</button>
      <button class="wire-btn default" (click)="logOut()" *ngIf="isAdmin">Log Out</button>
    </div>
  </div>
</div>
